export default "__VITE_ASSET__0be04980__"